import withStyles from '@mui/styles/withStyles'
import { withRouter } from 'next/router'
import React from 'react'
import { GetPaymentPlanDetails } from '../services/api-requests/api-request'
import Head from 'next/head'
import { WithRouterProps } from 'next/dist/client/with-router'
import { IUserDetails } from '../interfaces/user.interface'
import { GetUserDetails } from '../services/config'
import { IPaymentsPlan } from '../interfaces/IPaymentsPlan'
import { Button, Typography } from '@mui/material'
import SchoolClusterDetails from '../views/School/SchoolClusterDetails'
import { ISchool } from '../interfaces/school.interface'
import SchoolUserParentContainerComponent from '../containers/SchoolUser/SchoolUserParentContainerComponent'
import SchoolMaterialThemeContainer from '../containers/SchoolMaterialThemeContainer'
import SchoolUserPageHead from '../components/SchoolUserPageHead'

const styles = () => ({})

interface IClusterDetailsProps extends WithRouterProps {
  school_details: any
  cluster_slug: string
  cluster_id: string
  cluster_details: IPaymentsPlan
}

interface IClusterDetailsState {
  userDetails?: IUserDetails
  school_details: ISchool
  cluster_slug: string
  cluster_id: string
  cluster_details: IPaymentsPlan
}

class ClusterDetailsPage extends React.Component<
  IClusterDetailsProps,
  IClusterDetailsState
> {
  constructor(props: IClusterDetailsProps) {
    super(props)
    this.state = {
      school_details: this.props.school_details,
      cluster_details: this.props.cluster_details,
      cluster_id:
        this.props.cluster_id ||
        (this.props.router && (this.props.router.query.cluster_id as string)) ||
        '',
      cluster_slug: this.props.cluster_slug,
    }
  }

  static async getPaymentPlanDetails(clusterId: string) {
    try {
      const response = await GetPaymentPlanDetails(clusterId)
      return response?.data?.data
    } catch (err) {
      console.log('Error getting payment plan details', err)
    }
  }

  async getPaymentPlanDetails() {
    const responseData = await ClusterDetailsPage.getPaymentPlanDetails(
      this.state.cluster_id,
    )
    console.log('Instance getPaymentPlanDetails', responseData)
    if (responseData) {
      this.setState({
        cluster_details: responseData.cluster_details,
        cluster_slug: responseData.cluster_details.slug,
        cluster_id: responseData.cluster_details._id, // change state course_id to _id if it is a slug
        school_details: responseData.school_details,
      })
    }
  }

  componentDidMount() {
    this.setState({
      userDetails: GetUserDetails(),
    })
    // if cluster_id provided via route query (client-side), fetch details
    const clusterIdFromQuery =
      this.props.router && this.props.router.query
        ? (this.props.router.query.cluster_id as string)
        : undefined

    const clusterId = clusterIdFromQuery || this.state.cluster_id
    if (clusterId) {
      this.setState({ cluster_id: clusterId as string }, () => {
        this.getPaymentPlanDetails()
      })
    }
  }

  renderHead() {
    const cluster_details = this.props.cluster_details
    return (
      <Head>
        <title>{cluster_details && cluster_details.name}</title>
        <meta name="name" content={cluster_details.name} />
        <meta name="description" content={cluster_details.description} />
      </Head>
    )
  }

  render() {
    if (!this.props.cluster_details) {
      return (
        <div style={{ padding: '20px' }}>
          <Typography variant={'h6'}>Invalid cluster</Typography>
          <Button variant={'contained'} color={'primary'} href={'/'}>
            Go home
          </Button>
        </div>
      )
    }

    if (this.state.userDetails?.user_type !== 'student') {
      return (
        <SchoolMaterialThemeContainer schoolDetails={this.state.school_details}>
          <SchoolUserParentContainerComponent
            school_id={this.props.school_details._id}
            fb_pixel_id={this.props.school_details.fb_pixels_id}
          >
            <div>
              {this.renderHead()}
              <SchoolClusterDetails
                schoolDetails={this.state.school_details}
                clusterDetails={this.state.cluster_details}
                refreshStudentBillingData={() => {
                  this.getPaymentPlanDetails()
                }}
              />
            </div>
          </SchoolUserParentContainerComponent>
        </SchoolMaterialThemeContainer>
      )
    }

    return (
      <>
        {this.state.school_details && (
          <SchoolUserPageHead schoolDetails={this.state?.school_details} />
        )}
        <SchoolMaterialThemeContainer schoolDetails={this.state.school_details}>
          <SchoolUserParentContainerComponent
            school_id={this.props.school_details._id}
            fb_pixel_id={this.props.school_details.fb_pixels_id}
          >
            <div>
              {this.renderHead()}
              <div
                style={{ backgroundColor: '#f4f5f7', paddingBottom: '10px' }}
              >
                <SchoolClusterDetails
                  schoolDetails={this.state.school_details}
                  clusterDetails={this.state.cluster_details}
                  refreshStudentBillingData={() => {
                    this.getPaymentPlanDetails()
                  }}
                />
              </div>
            </div>
          </SchoolUserParentContainerComponent>
        </SchoolMaterialThemeContainer>
      </>
    )
  }
}

// Note: server-side fetching removed — cluster details are loaded client-side in componentDidMount

export default withRouter(withStyles(styles)(ClusterDetailsPage))
